import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { AlertCardComponent } from '../../../shared/components/alert-card/alert-card.component';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { NaturezaMovimentacaoEnum } from '../../../shared/enums/financas/natureza-movimentacao.enum';
import { TipoContaEnum } from '../../../shared/enums/financas/tipo-conta.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { CustomDateAdapter } from '../../../shared/services/custom-date-adapter';
import { MaskService } from '../../../shared/services/mask.service';
import { LimitDateValidator } from '../../../shared/validators/limit-date.validator';
import { ConciliacaoBancariaService } from '../../../shared/services/apis/financas/conciliacao-bancaria.service';
import { StatusConexaoEnum } from '../../../shared/enums/integracao-financas-banco/status-conexao.enum';
import { ConciliarRequest } from '../../../shared/services/requests/financas/conciliar.request';
import { ExtratoBancarioContaItem } from '../../../shared/services/responses/financas/extrato-bancario-contas.response';
import { ExtratoBancarioItemStruct as ExtratoBancarioItem } from '../../../shared/services/structs/financas/extrato-bancario-item.struct';
import { SugestaoMatchStruct as SugestaoMatch } from '../../../shared/services/structs/financas/sugestao-match.struct';
import { TipoMatchConciliacaoEnum } from '../../../shared/enums/financas/tipo-match-conciliacao.enum';
import { FinancasLookupService } from '../../../shared/services/apis/financas/financas-lookup.service';
import { FinancasLookupItem } from '../../../shared/services/responses/financas/lookup-online-select.response';
import {
  ImportarOfxDialogComponent,
} from './dialogs/importar-ofx-dialog/importar-ofx-dialog.component';
import {
  BuscarLancamentosDialogComponent,
  BuscarLancamentosDialogData,
} from './dialogs/buscar-lancamentos-dialog/buscar-lancamentos-dialog.component';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ExtratoService } from '../../../shared/services/apis/integracao-financas-banco/extrato.service';

export enum PeriodoConciliacaoEnum {
  Hoje = 1,
  DaSemana = 2,
  DoMes = 3,
  Ultimos30Dias = 4,
  DoIntervalo = 5,
}

interface LancamentoVm {
  item: ExtratoBancarioItem;
  sugestaoIdx: number;
  acaoAberta: 'transferencia' | 'novaMovimentacao' | null;
  isConciliando: boolean;
  formTransferencia: { idContaFinanceira: number | null; descricao: string };
  formNovaMovimentacao: {
    idCategoria: number | null;
    idCentroCusto: number | null;
  };
}

@Component({
  selector: 'app-conciliacao-bancaria-lancamentos',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HeaderComponent,
    EmptyListComponent,
    LoadingBoxComponent,
    AlertCardComponent,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    BuscarLancamentosDialogComponent,
    AbntPipe,
    ConfirmModalComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
  templateUrl: './conciliacao-bancaria-lancamentos.component.html',
  styleUrls: ['./conciliacao-bancaria-lancamentos.component.css'],
})
export class ConciliacaoBancariaLancamentosComponent implements OnInit {
  moduloEnum = ModuloEnum.Financas;
  funcionalidadeEnum = FuncionalidadeEnum.Financas_ConciliacaoBancaria;
  naturezaEnum = NaturezaMovimentacaoEnum;
  PeriodoConciliacaoEnum = PeriodoConciliacaoEnum;

  idContaFinanceira!: number;
  nomeBanco = '';
  agencia = '';
  numeroConta = '';
  descricaoContaFinanceira = '';

  _contas: ExtratoBancarioContaItem[] = [];
  isLoadingContas = false;

  statusConexaoExtrato: StatusConexaoEnum | null = null;
  statusConexaoEnum = StatusConexaoEnum;

  isLoading = false;
  isLoadingMais = false;
  _todosVm: LancamentoVm[] = [];
  _filtradosVm: LancamentoVm[] = [];
  _paginaAtual = 0;
  _temMais = false;

  filtroNatureza: number | null = null;
  pesquisa = '';

  // Período
  model!: FormGroup;
  periodoSelecionado: PeriodoConciliacaoEnum = PeriodoConciliacaoEnum.Ultimos30Dias;
  limiteMaxDias = 60;
  private periodoSelecionadoAplicado: PeriodoConciliacaoEnum = PeriodoConciliacaoEnum.Ultimos30Dias;
  private periodoIntervaloDeAplicado: Date | null = null;
  private periodoIntervaloAteAplicado: Date | null = null;
  private periodoMenuFoiAplicado = false;

  @ViewChild('periodoMenuTrigger') periodoMenuTrigger?: MatMenuTrigger;

  get totalTodos(): number { return this._todosVm.length; }
  get totalRecebimentos(): number { return this._todosVm.filter(v => v.item.idNaturezaMovimentacao === 1).length; }
  get totalPagamentos(): number { return this._todosVm.filter(v => v.item.idNaturezaMovimentacao === 2).length; }

  contasLookup: FinancasLookupItem[] = [];
  categoriasLookup: FinancasLookupItem[] = [];
  centrosCustoLookup: FinancasLookupItem[] = [];
  alertForaPeriodo: { quantidade: number; mesLabel: string; dataDe: Date; dataAte: Date } | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private conciliacaoBancariaService: ConciliacaoBancariaService,
    private financasLookupService: FinancasLookupService,
    private extratoService: ExtratoService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    const param = this.route.snapshot.paramMap.get('idContaFinanceira');
    this.idContaFinanceira = Number(param);

    const hoje = new Date();
    const trintaDiasAtras = new Date();
    trintaDiasAtras.setDate(hoje.getDate() - 30);

    this.model = this.fb.group({
      dataDe: [trintaDiasAtras, Validators.required],
      dataAte: [hoje, Validators.required],
    }, { validators: LimitDateValidator.rangeLimit(2) });

    this.salvarPeriodoAplicado();
    this.carregarContas();
    this.carregarLancamentos(true);
    this.carregarContasLookup();
    this.carregarStatusContaAtual();
    this.carregarCategoriasLookup();
    this.carregarCentrosCustoLookup();
  }

  private carregarContas(): void {
    this.isLoadingContas = true;
    this.conciliacaoBancariaService.getContas().subscribe({
      next: (res) => {
        this.isLoadingContas = false;
        if (!res.isError) this._contas = res.contas;
      },
      error: () => { this.isLoadingContas = false; },
    });
  }

  onContaChange(idContaFinanceira: number): void {
    const conta = this._contas.find(c => c.idContaFinanceira === idContaFinanceira);
    if (conta?.idTipoConta === TipoContaEnum.CartaoCredito) {
      this.router.navigate(
        ['/financas/conciliacao-bancaria/cartao/lancamentos', idContaFinanceira],
        { replaceUrl: true }
      );
      return;
    }
    this.idContaFinanceira = idContaFinanceira;
    this.router.navigate(
      ['/financas/conciliacao-bancaria/lancamentos', idContaFinanceira],
      { replaceUrl: true }
    );
    this.pesquisa = '';
    this.filtroNatureza = null;
    this.statusConexaoExtrato = null;
    this.carregarLancamentos(true);
    this.carregarStatusContaAtual();
  }

  carregarLancamentos(resetar = true): void {
    if (resetar) {
      if (this.isLoading) return;
      this._paginaAtual = 0;
      this._todosVm = [];
      this._temMais = false;
      this.alertForaPeriodo = null;
      this.isLoading = true;
    } else {
      if (this.isLoadingMais) return;
      this.isLoadingMais = true;
    }

    const formValue = this.model.getRawValue();
    const dataInicio = formValue.dataDe ? this.formatDate(new Date(formValue.dataDe)) : null;
    const dataFim = formValue.dataAte ? this.formatDate(new Date(formValue.dataAte)) : null;

    this.conciliacaoBancariaService.getLancamentos({
      idContaFinanceira: this.idContaFinanceira,
      dataInicio,
      dataFim,
      pageIndex: this._paginaAtual,
    }).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.isLoadingMais = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        if (resetar) {
          this.nomeBanco = res.nomeBanco;
          this.agencia = res.agencia;
          this.numeroConta = res.numeroConta;
          this.descricaoContaFinanceira = res.descricaoContaFinanceira;

          if (res.pendentesForaPeriodo > 0 && res.dataMaisProximaPendente) {
            const data = new Date(res.dataMaisProximaPendente);
            this.alertForaPeriodo = {
              quantidade: res.pendentesForaPeriodo,
              mesLabel: this._formatarMes(data),
              dataDe: new Date(data.getFullYear(), data.getMonth(), 1),
              dataAte: new Date(data.getFullYear(), data.getMonth() + 1, 0),
            };
          }
        }
        const novosVm = res.itens.map(item => ({
          item,
          sugestaoIdx: 0,
          acaoAberta: null as 'transferencia' | 'novaMovimentacao' | null,
          isConciliando: false,
          formTransferencia: { idContaFinanceira: null, descricao: '' },
          formNovaMovimentacao: { idCategoria: null, idCentroCusto: null },
        }));
        this._todosVm = [...this._todosVm, ...novosVm];
        this._temMais = res.temMais;
        this.aplicarFiltros();
      },
      error: (err) => {
        this.isLoading = false;
        this.isLoadingMais = false;
        this.alertService.show('Erro', err.message, AlertType.error);
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual++;
    this.carregarLancamentos(false);
  }

  setFiltro(natureza: number | null): void {
    this.filtroNatureza = natureza;
    this.aplicarFiltros();
  }

  aplicarFiltros(): void {
    let lista = this._todosVm;
    if (this.filtroNatureza !== null)
      lista = lista.filter(v => v.item.idNaturezaMovimentacao === this.filtroNatureza);
    if (this.pesquisa.trim())
      lista = lista.filter(v => v.item.memo?.toLowerCase().includes(this.pesquisa.trim().toLowerCase()));
    this._filtradosVm = [...lista].sort((a, b) =>
      (b.item.sugestoes.length > 0 ? 1 : 0) - (a.item.sugestoes.length > 0 ? 1 : 0)
    );
  }

  getSugestaoAtual(vm: LancamentoVm): SugestaoMatch | null {
    return vm.item.sugestoes[vm.sugestaoIdx] ?? null;
  }

  trocarSugestao(vm: LancamentoVm): void {
    vm.sugestaoIdx = (vm.sugestaoIdx + 1) % vm.item.sugestoes.length;
  }

  tipoMatchLabel(tipo: number): string {
    switch (tipo) {
      case TipoMatchConciliacaoEnum.Movimentacao: return 'Movimentação';
      case TipoMatchConciliacaoEnum.ContaPagar: return 'Conta a Pagar';
      case TipoMatchConciliacaoEnum.ContaReceber: return 'Conta a Receber';
      default: return String(tipo);
    }
  }

  stripHtml(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/<[^>]*>/g, '').trim();
  }

  labelConta(conta: ExtratoBancarioContaItem): string {
    let label = `${conta.nomeBanco} — ${conta.descricao} (Ag. ${conta.agencia})`;
    if (conta.totalPendentes > 0) label += ` · ${conta.totalPendentes} pendente(s)`;
    return label;
  }

  private carregarContasLookup(): void {
    this.financasLookupService.listContaFinanceiraSelect().subscribe({
      next: (res) => {
        if (!res.isError)
          this.contasLookup = res.list;
      },
    });
  }

  private carregarCategoriasLookup(): void {
    this.financasLookupService.listCategoriaFinanceiraSelect().subscribe({
      next: (res) => {
        if (!res.isError) this.categoriasLookup = res.list;
      },
    });
  }

  private carregarCentrosCustoLookup(): void {
    this.financasLookupService.listCentroCustoSelect().subscribe({
      next: (res) => {
        if (!res.isError) this.centrosCustoLookup = res.list;
      },
    });
  }

  abrirNovaMovimentacao(vm: LancamentoVm): void {
    vm.acaoAberta = 'novaMovimentacao';
    vm.formNovaMovimentacao = { idCategoria: null, idCentroCusto: null };
  }

  confirmarNovaMovimentacao(vm: LancamentoVm): void {
    if (vm.isConciliando) return;
    vm.isConciliando = true;
    const req: ConciliarRequest = {
      idExtratoBancario: vm.item.idExtratoBancario,
      idsMovimentacao: [],
      idsContasPagarParcela: [],
      idsContasReceberParcela: [],
      novaMovimentacaoAvulsa: true,
      idCategoriaFinanceiraNovaMov: vm.formNovaMovimentacao.idCategoria ?? null,
      idCentroCustoNovaMov: vm.formNovaMovimentacao.idCentroCusto ?? null,
    };
    this.conciliacaoBancariaService.conciliar(req).subscribe({
      next: (res) => {
        vm.isConciliando = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Sucesso', 'Movimentação criada e conciliada com sucesso.', AlertType.success);
        this._removerDaLista(vm);
      },
      error: (err) => {
        vm.isConciliando = false;
        this.alertService.show('Erro', err.message, AlertType.error);
      },
    });
  }

  labelContaTransferencia(vm: LancamentoVm): string {
    return vm.item.idNaturezaMovimentacao === this.naturezaEnum.Saida
      ? 'Conta de Destino'
      : 'Conta de Origem';
  }

  contasLookupFiltradas(_vm: LancamentoVm): FinancasLookupItem[] {
    return this.contasLookup.filter(c => c.id !== this.idContaFinanceira);
  }

  abrirTransferencia(vm: LancamentoVm): void {
    vm.acaoAberta = 'transferencia';
    vm.formTransferencia = { idContaFinanceira: null, descricao: '' };
  }

  fecharAcao(vm: LancamentoVm): void {
    vm.acaoAberta = null;
  }

  conciliarMatch(vm: LancamentoVm): void {
    const s = this.getSugestaoAtual(vm);
    if (!s || vm.isConciliando) return;
    vm.isConciliando = true;
    const req = this._buildRequestMatch(vm, s);
    this.conciliacaoBancariaService.conciliar(req).subscribe({
      next: (res) => {
        vm.isConciliando = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show('Sucesso', 'Lançamento conciliado com sucesso.', AlertType.success);
        this._removerDaLista(vm);
      },
      error: (err) => {
        vm.isConciliando = false;
        this.alertService.show('Erro', err.message, AlertType.error);
      },
    });
  }

  conciliarTransferencia(vm: LancamentoVm): void {
    if (!vm.formTransferencia.idContaFinanceira || vm.isConciliando) return;
    vm.isConciliando = true;
    const req: ConciliarRequest = {
      idExtratoBancario: vm.item.idExtratoBancario,
      idsMovimentacao: [],
      idsContasPagarParcela: [],
      idsContasReceberParcela: [],
      idContaFinanceiraTransferencia: vm.formTransferencia.idContaFinanceira,
      descricaoTransferencia: vm.formTransferencia.descricao || null,
    };
    this.conciliacaoBancariaService.conciliar(req).subscribe({
      next: (res) => {
        vm.isConciliando = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Sucesso', 'Transferência conciliada com sucesso.', AlertType.success);
        this._removerDaLista(vm);
      },
      error: (err) => {
        vm.isConciliando = false;
        this.alertService.show('Erro', err.message, AlertType.error);
      },
    });
  }

  ignorar(vm: LancamentoVm): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '400px',
      data: {
        title: 'Ignorar lançamento',
        innerHtml: `<p>Tem certeza que deseja ignorar este lançamento?</p><p>Ele deixará de aparecer na lista de pendências.</p><p>Você poderá reverter esta ação buscando o lançamento na lista de ignorados.</p>`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result?.confirm) return;

      vm.isConciliando = true;
      this.conciliacaoBancariaService.ignorarLancamento(vm.item.idExtratoBancario).subscribe({
        next: (res) => {
          vm.isConciliando = false;
          if (res.isError) {
            this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
            return;
          }
          this.alertService.show('Sucesso', 'Lançamento ignorado com sucesso.', AlertType.success);
          this.carregarLancamentos(true);
        },
        error: (err) => {
          vm.isConciliando = false;
          this.alertService.show('Erro', err.message, AlertType.error);
        }
      });
    });
  }

  private _buildRequestMatch(vm: LancamentoVm, s: SugestaoMatch): ConciliarRequest {
    const req: ConciliarRequest = {
      idExtratoBancario: vm.item.idExtratoBancario,
      idsMovimentacao: [],
      idsContasPagarParcela: [],
      idsContasReceberParcela: [],
    };
    switch (s.tipoMatch) {
      case TipoMatchConciliacaoEnum.Movimentacao:
        req.idsMovimentacao = [s.idRegistro];
        break;
      case TipoMatchConciliacaoEnum.ContaPagar:
        req.idsContasPagarParcela = [s.idRegistro];
        break;
      case TipoMatchConciliacaoEnum.ContaReceber:
        req.idsContasReceberParcela = [s.idRegistro];
        break;
    }
    return req;
  }

  ignorarSugestao(vm: LancamentoVm): void {
    vm.item.sugestoes.splice(vm.sugestaoIdx, 1);
    if (vm.sugestaoIdx >= vm.item.sugestoes.length)
      vm.sugestaoIdx = Math.max(0, vm.item.sugestoes.length - 1);
    this.aplicarFiltros();
  }

  private _removerDaLista(vm: LancamentoVm): void {
    this._todosVm = this._todosVm.filter(v => v !== vm);
    this.aplicarFiltros();
  }

  abrirModalAssociarExistente(vm: LancamentoVm): void {
    const dialogRef = this.dialog.open(BuscarLancamentosDialogComponent, {
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        idContaFinanceira: this.idContaFinanceira,
        extrato: vm.item,
      } as BuscarLancamentosDialogData,
    });

    dialogRef.afterClosed().subscribe((conciliado: boolean) => {
      if (conciliado) this.carregarLancamentos(true);
    });
  }

  abrirModalImportacao(): void {
    const dialogRef = this.dialog.open(ImportarOfxDialogComponent, {
      width: '520px',
      disableClose: true,
      data: { idContaFinanceira: this.idContaFinanceira },
    });

    dialogRef.afterClosed().subscribe((importado: boolean) => {
      if (importado) {
        this.carregarLancamentos(true);
      }
    });
  }

  private carregarStatusContaAtual(): void {
    this.extratoService.getStatusExtratoContas([this.idContaFinanceira]).subscribe({
      next: res => {
        const item = res.contas.find(c => c.idContaFinanceira === this.idContaFinanceira);
        this.statusConexaoExtrato = item ? (item.idStatusConexao as StatusConexaoEnum) : null;
      },
    });
  }

  get bancoDaContaSuportaOpenFinance(): boolean {
    const conta = this._contas.find(c => c.idContaFinanceira === this.idContaFinanceira);
    return !!conta?.suportaExtratoOpenFinance;
  }

  irParaConfiguracaoIntegracao(): void {
    this.router.navigate(
      ['/configuracoes/financas/contas-financeiras/cadastrar', this.idContaFinanceira],
      { queryParams: { abrirIntegracao: true } }
    );
  }

  navegarParaMesPendente(): void {
    if (!this.alertForaPeriodo) return;
    this.periodoSelecionado = PeriodoConciliacaoEnum.DoIntervalo;
    this.model.patchValue({
      dataDe: this.alertForaPeriodo.dataDe,
      dataAte: this.alertForaPeriodo.dataAte,
    });
    this.alertForaPeriodo = null;
    this.salvarPeriodoAplicado();
    this.carregarLancamentos(true);
  }

  private _formatarMes(data: Date): string {
    const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho',
      'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    return `${meses[data.getMonth()]}/${data.getFullYear()}`;
  }

  voltar(): void {
    this.router.navigate(['/financas/conciliacao-bancaria']);
  }

  // ── Período ────────────────────────────────────────────────────────────────

  get periodoLabel(): string {
    switch (this.periodoSelecionado) {
      case PeriodoConciliacaoEnum.Hoje: return 'hoje';
      case PeriodoConciliacaoEnum.DaSemana: return 'desta semana';
      case PeriodoConciliacaoEnum.DoMes: return 'do mês';
      case PeriodoConciliacaoEnum.Ultimos30Dias: return 'últimos 30 dias';
      case PeriodoConciliacaoEnum.DoIntervalo: return 'do intervalo';
      default: return 'últimos 30 dias';
    }
  }

  selecionarPeriodo(periodo: PeriodoConciliacaoEnum): void {
    this.periodoSelecionado = periodo;
    if (periodo !== PeriodoConciliacaoEnum.DoIntervalo)
      this.calcularDatasParaPeriodo(periodo);
  }

  private calcularDatasParaPeriodo(periodo: PeriodoConciliacaoEnum): void {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    let dataDe: Date;
    let dataAte: Date;

    switch (periodo) {
      case PeriodoConciliacaoEnum.Hoje:
        dataDe = new Date(hoje);
        dataAte = new Date(hoje);
        break;
      case PeriodoConciliacaoEnum.DaSemana: {
        dataDe = new Date(hoje);
        dataDe.setDate(hoje.getDate() - hoje.getDay());
        dataAte = new Date(dataDe);
        dataAte.setDate(dataDe.getDate() + 6);
        break;
      }
      case PeriodoConciliacaoEnum.DoMes: {
        dataDe = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        dataAte = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        break;
      }
      case PeriodoConciliacaoEnum.Ultimos30Dias:
      default: {
        dataDe = new Date(hoje);
        dataDe.setDate(hoje.getDate() - 30);
        dataAte = new Date(hoje);
        break;
      }
    }

    this.model.patchValue({ dataDe, dataAte });
  }

  aplicarPeriodo(trigger?: MatMenuTrigger): void {
    if (this.periodoSelecionado === PeriodoConciliacaoEnum.DoIntervalo) {
      this.model.get('dataDe')?.markAsTouched();
      this.model.get('dataAte')?.markAsTouched();

      if (this.model.get('dataAte')?.hasError('dataInvalida')) {
        this.alertService.show('Atenção', 'A data final não pode ser menor que a data inicial.', AlertType.warning);
        return;
      }
      if (this.model.get('dataAte')?.hasError('intervaloExcedido')) {
        this.alertService.show('Atenção', `O intervalo máximo permitido é de ${this.limiteMaxDias} dias.`, AlertType.warning);
        return;
      }
      if (this.model.get('dataDe')?.hasError('required') || this.model.get('dataAte')?.hasError('required')) {
        this.alertService.show('Atenção', 'Preencha as duas datas do intervalo.', AlertType.warning);
        return;
      }

      // Validação extra: máximo 60 dias
      const de = new Date(this.model.get('dataDe')!.value);
      const ate = new Date(this.model.get('dataAte')!.value);
      const diffDias = Math.ceil((ate.getTime() - de.getTime()) / (1000 * 60 * 60 * 24));
      if (diffDias > this.limiteMaxDias) {
        this.alertService.show('Atenção', `O intervalo máximo permitido é de ${this.limiteMaxDias} dias.`, AlertType.warning);
        return;
      }
    }

    this.periodoMenuFoiAplicado = true;
    this.salvarPeriodoAplicado();
    this.carregarLancamentos(true);
    const menuTrigger = trigger ?? this.periodoMenuTrigger;
    setTimeout(() => menuTrigger?.closeMenu());
  }

  prepararPeriodoIntervalo(): void {
    this.periodoMenuFoiAplicado = false;
  }

  cancelarPeriodoIntervalo(trigger?: MatMenuTrigger): void {
    this.restaurarPeriodoAplicado();
    this.periodoMenuFoiAplicado = true;
    const menuTrigger = trigger ?? this.periodoMenuTrigger;
    setTimeout(() => menuTrigger?.closeMenu());
  }

  onPeriodoMenuClosed(): void {
    if (!this.periodoMenuFoiAplicado)
      this.restaurarPeriodoAplicado();
  }

  onDateInput(event: Event): void {
    MaskService.onDateInput(event);
  }

  private salvarPeriodoAplicado(): void {
    this.periodoSelecionadoAplicado = this.periodoSelecionado;
    this.periodoIntervaloDeAplicado = this.cloneDate(this.model.get('dataDe')?.value);
    this.periodoIntervaloAteAplicado = this.cloneDate(this.model.get('dataAte')?.value);
  }

  private restaurarPeriodoAplicado(): void {
    this.periodoSelecionado = this.periodoSelecionadoAplicado;
    this.model.patchValue({
      dataDe: this.cloneDate(this.periodoIntervaloDeAplicado),
      dataAte: this.cloneDate(this.periodoIntervaloAteAplicado),
    });
  }

  private cloneDate(data: Date | null): Date | null {
    return data ? new Date(data) : null;
  }

  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
}
